module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.20e9f646.svg";